import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const deleteQuestionFile = async (attachId, questionId) => {
	try {
		client.delete(`${uri}/question_attachment`, {
			params: {
				questionId,
				attachId,
			},
			headers: authHeader(),
		});
	} catch (e) {
		console.error(e);
		message.error("Не получилось удалить вложение вопроса, попробуйте позже");
	}
};

export default deleteQuestionFile;
